import { TableHeadersType } from "../tableHeadersType";

export const LEAVE_HISTORYT_HEADERS: TableHeadersType[] = [
  {
    label: "APPLIED ON",
    value: "applied_on",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "LEAVE FROM",
    value: "leave_from",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "LEAVE TO",
    value: "leave_to",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "NO. OF DAY",
    value: "no_of_days",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "APPROVED / REJECT BY",
    value: "approved_by",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "LEAVE TYPE",
    value: "leave_type",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "REASON",
    value: "reason",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "STATUS",
    value: "status",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "ACTION",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
  
  
];
export const WFH_HISTORYT_HEADERS: TableHeadersType[] = [
  {
    label: "APPLIED ON",
    value: "applied_on",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "WFH FROM",
    value: "wfh_from",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "WFH TO",
    value: "wfh_to",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "NO. OF DAY",
    value: "no_of_days",
    checked: true,
    defaultChecked: true,
  },
    {
    label: "APPROVED / REJECT BY",
    value: "approved_by",
    checked: true,
    defaultChecked: true,
  },
  // {
  //   label: "WFH TYPE",
  //   value: "wfh_type",
  //   checked: true,
  //   defaultChecked: true,
  // },
  {
    label: "REASON",
    value: "reason",
    checked: true,
    defaultChecked: true,
  },
    {
    label: "STATUS",
    value: "status",
    checked: true,
    defaultChecked: true,
  },
  
   {
    label: "ACTION",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
  
  
];
export const LEAVE_PENDING_HEADERS: TableHeadersType[] = [
  {
    label: "APPLIED ON",
    value: "applied_on",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "LEAVE FROM",
    value: "leave_from",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "LEAVE TO",
    value: "leave_to",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "NO. OF DAY",
    value: "no_of_days",
    checked: true,
    defaultChecked: true,
  },
    {
    label: "LEAVE APPLIED BY",
    value: "leave_applied_by",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "LEAVE TYPE",
    value: "leave_type",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "REASON",
    value: "reason",
    checked: true,
    defaultChecked: true,
  },
   {
    label: "STATUS",
    value: "status",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "ACTION",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
];
export const LEAVE_APPROVED_HEADERS: TableHeadersType[] = [
  {
    label: "APPLIED ON",
    value: "applied_on",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "LEAVE FROM",
    value: "leave_from",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "LEAVE TO",
    value: "leave_to",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "NO. OF DAY",
    value: "no_of_days",
    checked: true,
    defaultChecked: true,
  },
    {
    label: "LEAVE APPLIED BY",
    value: "leave_applied_by",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "LEAVE TYPE",
    value: "leave_type",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "REASON",
    value: "reason",
    checked: true,
    defaultChecked: true,
  },
  
  {
    label: "STATUS",
    value: "status",
    checked: true,
    defaultChecked: true,
  },
   {
    label: "ACTION",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
  
];
export const WFH_PENDING_APPROVED_HEADERS: TableHeadersType[] = [
  {
    label: "APPLIED ON",
    value: "applied_on",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "WFH FROM",
    value: "wfh_from",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "WFH TO",
    value: "wfh_to",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "NO. OF DAY",
    value: "no_of_days",
    checked: true,
    defaultChecked: true,
  },
    {
    label: "WFH APPLIED BY",
    value: "wfh_applied_by",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "WFH TYPE",
    value: "wfh_type",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "REASON",
    value: "reason",
    checked: true,
    defaultChecked: true,
  },
  
  {
    label: "STATUS",
    value: "status",
    checked: true,
    defaultChecked: true,
  },
   {
    label: "ACTION",
    value: "action",
    checked: true,
    defaultChecked: true,
  },
  
];
